// based on https://stackoverflow.com/a/10469752
export function humanReadableLits(lits: number) {
  if (lits === 0) return "0";
  const s = ["", "K", "M"];
  const e = Math.floor(Math.log(lits) / Math.log(1000));
  return Math.round((lits / Math.pow(1000, e)) * 100) / 100 + s[e];
}
